<template>
  <fragment>
    <AppBody
      title="Relatórios Analíticos"
      subtitle="Venda Detalhada ElevenTickets"
      info
      infoMessage="Este relatório permite, no máximo, um intervalo de 3 meses para geração."
      disableDivider
    >
      <CardModule untitle>
        <v-form
          @submit.prevent="$relatorios_analiticos.filtroAnaliticoOmni()"
          class="search-forms"
        >
          <v-row>
            <v-col cols="12" md="3" sm="4" v-if="isAdmin">
              <BaseSelect
                label="Regional"
                tabindex="3"
                :items="$loja_gerenciar.regionais"
                data-cy="regional"
                loader-height="5"
                v-model="$relatorios_analiticos.filterOmni.regional"
                item-text="nome"
                item-value="idregional"
                placeholder="Selecione a Regional"
                :disabled="disableRegionais"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterOmniFields('regional')
                "
              />
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                label="Estado"
                tabindex="5"
                item-text="dsc_lang"
                item-value="iso_full"
                return-object
                placeholder="Selecione o estado"
                autocomplete="null"
                auto-select-first
                clearable
                :loading="$config.loading_estados"
                :items="$config.estados.result"
                v-model="estado"
                @click:clear="
                  $relatorios_analiticos.clearfilterOmniFields('estado')
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseAutocomplete
                label="Cidade"
                tabindex="6"
                item-text="dsc_lang"
                item-value="dsc_lang"
                placeholder="Selecione a cidade"
                clearable
                :loading="$config.loading_cidades"
                :items="$config.cidades.result"
                v-model="$relatorios_analiticos.filterOmni.cidade"
                @click:clear="
                  $relatorios_analiticos.clearfilterOmniFields('cidade')
                "
              >
              </BaseAutocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4" v-if="isAdmin">
              <BaseSelect
                label="Canal de Venda"
                tabindex="7"
                :items="$relatorios_analiticos.canais_de_venda"
                data-cy="canal-venda"
                v-model="$relatorios_analiticos.filterOmni.canal_de_venda"
                item-text="value"
                item-value="key"
                placeholder="Selecione o Canal de Venda"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterOmniFields('canal_de_venda')
                "
              />
            </v-col>
            <v-col cols="12" md="3" sm="4" v-if="isAdmin">
              <BaseSelect
                label="Forma de Pagamento"
                tabindex="8"
                :items="$relatorios_analiticos.formas_de_pagamento"
                data-cy="forma-pagamento"
                v-model="$relatorios_analiticos.filterOmni.forma_de_pagamento"
                item-text="key"
                item-value="value"
                placeholder="Selecione a Forma de Pagamento"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterOmniFields(
                    'forma_de_pagamento'
                  )
                "
              />
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                label="Intervalo de Datas"
                tabindex="9"
                :items="$relatorios_analiticos.intervalo_data"
                item-text="text"
                item-value="value"
                data-cy="intervalo-datas"
                v-model="$relatorios_analiticos.filterOmni.intervalo_datas"
                placeholder="Selecione o intervalo de datas"
                clearable
                @click:clear="
                  $relatorios_analiticos.clearfilterOmniFields(
                    'intervalo_datas'
                  )
                "
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="
                $relatorios_analiticos.filterOmni.intervalo_datas != 'custom'
              "
            >
              <v-menu
                tabindex="10"
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    readonly
                    data-cy="datas"
                    :append-icon="$config.icons.calendar"
                    :disabled="
                      $relatorios_analiticos.filterOmni.intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    :error-messages="
                      $relatorios_analiticos.filterOmni.error.range_dates
                    "
                    @input="
                      $relatorios_analiticos.filterOmni.error.range_dates = []
                    "
                    @click:clear="
                      $relatorios_analiticos.clearfilterOmniFields('dates')
                    "
                  ></BaseTextField>
                </template>
                <v-date-picker
                  v-model="computeRange"
                  :active-picker.sync="activePicker"
                  @change="computeRange"
                  locale="pt"
                  :header-color="$config.dados.corinputs"
                  landscape
                  @input="menu = false"
                  :color="$config.dados.corinputs"
                  range
                  @click:month="monthEvent"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" sm="4" v-else>
              <v-menu
                tabindex="11"
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    readonly
                    :append-icon="$config.icons.calendar"
                    :disabled="
                      $relatorios_analiticos.filterOmni.intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    :error-messages="
                      $relatorios_analiticos.filterOmni.error.range_dates
                    "
                    @input="
                      $relatorios_analiticos.filterOmni.error.range_dates = []
                    "
                    @click:clear="
                      $relatorios_analiticos.clearfilterOmniFields('dates')
                    "
                  >
                  </BaseTextField>
                </template>
                <v-date-picker
                  v-model="$relatorios_analiticos.filterOmni.range_dates"
                  :active-picker.sync="activePicker"
                  locale="pt"
                  :header-color="$config.dados.corinputs"
                  landscape
                  @input="
                    $relatorios_analiticos.filterOmni.range_dates.length == 2
                      ? (menu = false)
                      : (menu = true)
                  "
                  :color="$config.dados.corinputs"
                  range
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <v-menu
                tabindex="12"
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Hora Inicial"
                    data-cy="hora-inicial"
                    v-model="horaInicial"
                    :append-icon="$config.icons.clock"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterOmni.intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderHora"
                    :color="$config.dados.corinputs"
                  >
                  </BaseTextField>
                </template>
                <v-time-picker
                  v-model="$relatorios_analiticos.filterOmni.hora_inicial"
                  :active-picker.sync="activePicker2"
                  @change="save2"
                  locale="pt"
                  format="24hr"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                >
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <v-menu
                tabindex="13"
                ref="menu3"
                v-model="menu3"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Hora Final"
                    data-cy="hora-final"
                    v-model="horaFinal"
                    :append-icon="$config.icons.clock"
                    readonly
                    :disabled="
                      $relatorios_analiticos.filterOmni.intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderHora"
                    :color="$config.dados.corinputs"
                  >
                  </BaseTextField>
                </template>
                <v-time-picker
                  v-model="$relatorios_analiticos.filterOmni.hora_final"
                  :active-picker.sync="activePicker3"
                  @change="save3"
                  locale="pt"
                  format="24hr"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  range
                >
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="!isAdmin"
              class="d-flex justify-end"
            >
              <BaseButton
                tabindex="14"
                variant="filter"
                class="button rounded-xxl"
                type="submit"
                :loading="$relatorios_analiticos.loading_button_omni"
              >
                Gerar e Enviar por E-mail
              </BaseButton>
            </v-col>
            <v-col class="d-flex justify-end" v-if="isAdmin">
              <BaseButton
                tabindex="15"
                variant="filter"
                class="button rounded-xxl"
                type="submit"
                :loading="$relatorios_analiticos.loading_button_omni"
              >
                Gerar e Enviar por E-mail
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import dayjs from "dayjs";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "GeneralAnalyticalEleventickets",
  metaInfo: {
    title:
      "Relatório Analítico de Venda Detalhada ElevenTickets | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content:
          "Relatório Analítico de Venda Detalhada ElevenTickets | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    BaseSelect,
    BaseAutocomplete,
    BaseTextField,
    BaseButton,
    AppBody,
  },
  data() {
    return {
      dayjs: dayjs,
      headers: [
        {
          text: "Produto",
          align: "center",
          sortable: false,
          value: "desc_produto",
          width: 200,
        },
        {
          text: "Quant. de Pedidos",
          align: "center",
          value: "qtd_pedido",
          width: 180,
        },
        {
          text: "Quant. de Itens",
          align: "center",
          value: "qtd_itens_pedido",
          width: 150,
        },
        {
          text: "Valor do Item",
          align: "center",
          value: "valor_item",
          width: 180,
        },
        {
          text: "Valor",
          align: "center",
          value: "valor",
          width: 180,
        },
        {
          text: "Juros",
          align: "center",
          value: "valor_juros",
          width: 180,
        },
        {
          text: "Desconto",
          align: "center",
          value: "valor_desconto",
          width: 200,
        },
        {
          text: "Total",
          align: "center",
          value: "valor_total",
          width: 180,
        },
      ],
      headersTotais: [
        {
          text: "Total de Pedidos",
          align: "center",
          sortable: false,
          value: "qtd_pedido",
          width: 180,
        },
        {
          text: "Total de Itens",
          align: "center",
          sortable: false,
          value: "qtd_itens_pedido",
          width: 150,
        },
        {
          text: "Valor Total",
          align: "center",
          sortable: false,
          value: "valor",
          width: 180,
        },
        {
          text: "Total Taxa de Conveniência",
          align: "center",
          sortable: false,
          value: "taxa_conveniencia",
          width: 200,
        },
        {
          text: "Total Taxa de Processamento",
          align: "center",
          sortable: false,
          value: "taxa_processamento",
          width: 200,
        },
        {
          text: "Total de Juros",
          align: "center",
          sortable: false,
          value: "valor_juros",
          width: 180,
        },
        {
          text: "Total de Desconto",
          align: "center",
          sortable: false,
          value: "valor_desconto",
          width: 200,
        },
        {
          text: "Total",
          align: "center",
          sortable: false,
          value: "valor_total",
          width: 180,
        },
      ],
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      date: null,
      hour: null,
      menu: false,
      menu2: false,
      menu3: false,
      horaInicial: null,
      horaFinal: null,
      estado: null,
      cidades: [],
      placeholderData: "dd/mm/aa ~ dd/mm/aa",
      placeholderHora: "hh:mm",
      disableRegionais: false,
      produtos: [],
    };
  },
  watch: {
    estado(state) {
      const { id, iso_full } = state;
      this.$relatorios_analiticos.filterOmni.estado = iso_full;

      const filteredId = this.$config.estados.result.find(
        item => item.dsc === state
      );

      this.$config.getCidades(id || filteredId.id);
    },
    "$relatorios_analiticos.filterOmni.loja"(e) {
      if (e === null || e === undefined || e === "") {
        this.disableRegionais = false;
        return;
      } else {
        this.disableRegionais = true;
        this.$produtos_gerenciar.getProdutos(e);
      }
    },
    "$relatorios_analiticos.filterOmni.regional"(e) {
      if (e === null) {
        this.$relatorios_analiticos.getAllLojas();
        return;
      }
      this.$relatorios_analiticos.getLojasByRegional(e);
    },
    "$relatorios_analiticos.filterOmni.intervalo_datas"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          // const day = new Date(new Date(currentDay).setDate(new Date(currentDay).getDate() + 1)).toISOString().slice(0, 10);
          this.$relatorios_analiticos.filterOmni.range_dates = [
            currentDay,
            currentDay,
          ];
          this.$relatorios_analiticos.filterOmni.hora_inicial = "00:00";
          this.horaInicial = "00:00";
          this.$relatorios_analiticos.filterOmni.hora_final = "23:59";
          this.horaFinal = "23:59";
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterOmni.range_dates = [
            currentDayWeek,
            week,
          ];
          this.$relatorios_analiticos.filterOmni.hora_inicial = "00:00";
          this.horaInicial = "00:00";
          this.$relatorios_analiticos.filterOmni.hora_final = "23:59";
          this.horaFinal = "23:59";
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.$relatorios_analiticos.filterOmni.range_dates = [
            currentDayMonth,
            month,
          ];
          this.$relatorios_analiticos.filterOmni.hora_inicial = "00:00";
          this.horaInicial = "00:00";
          this.$relatorios_analiticos.filterOmni.hora_final = "23:59";
          this.horaFinal = "23:59";
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_analiticos.filterOmni.range_dates = [
            currentDayCustom,
            custom,
          ];
          this.$relatorios_analiticos.filterOmni.hora_inicial = "00:00";
          this.horaInicial = "00:00";
          this.$relatorios_analiticos.filterOmni.hora_final = "23:59";
          this.horaFinal = "23:59";
          break;
        }
        default: {
          this.$relatorios_analiticos.filterOmni.range_dates = [];
          this.$relatorios_analiticos.filterOmni.hora_inicial = null;
          this.horaInicial = null;
          this.$relatorios_analiticos.filterOmni.hora_final = null;
          this.horaFinal = null;
          break;
        }
      }
    },
    menu(val) {
      val &&
        setTimeout(() => {
          if (
            val &&
            this.$relatorios_analiticos.filterOmni.intervalo_datas == "date"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterOmni.intervalo_datas == "week"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_analiticos.filterOmni.intervalo_datas == "month"
          ) {
            this.activePicker = "MONTH";
          } else if (
            val &&
            this.$relatorios_analiticos.filterOmni.intervalo_datas == "custom"
          ) {
            this.activePicker = "DATE";
          } else {
            this.activePicker = "DATE";
          }
        });
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "HOUR"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    dateRangeText(e) {
      if (e) {
        this.$relatorios_analiticos.filterOmni.error.range_dates = [];
      }
    },
  },
  methods: {
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    save2(hour) {
      this.$refs.menu2.save(hour);
      this.horaInicial = hour;
    },
    save3(hour) {
      this.$refs.menu3.save(hour);
      this.horaFinal = hour;
    },
    monthEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.$relatorios_analiticos.filterOmni.range_dates = [
        currentDayMonth,
        monthEnd,
      ];
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    exportCSV() {
      this.$relatorios_analiticos.imprimirCSVGeral();
    },
    exportAction() {
      this.$relatorios_analiticos.imprimirPDFGeral();
    },
  },
  computed: {
    computeRange: {
      get() {
        return this.$relatorios_analiticos.filterOmni.range_dates;
      },
      set([firstDay]) {
        switch (this.$relatorios_analiticos.filterOmni.intervalo_datas) {
          case "date": {
            // const day = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate() + 1)).toISOString().slice(0, 10);
            this.$relatorios_analiticos.filterOmni.range_dates = [
              firstDay,
              firstDay,
            ];
            break;
          }
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterOmni.range_dates = [
              currentDayWeek,
              week,
            ];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.$relatorios_analiticos.filterOmni.range_dates = [
              currentDayMonth,
              month,
            ];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.$relatorios_analiticos.filterOmni.range_dates = [
              currentDayCustom,
              custom,
            ];
            break;
          }
          default: {
            const defaultDay = "";
            this.$relatorios_analiticos.filterOmni.range_dates = [
              firstDay,
              defaultDay,
            ];
            break;
          }
        }
      },
    },
    dateRangeText() {
      let arrayDates = [];
      this.$relatorios_analiticos?.filterOmni?.range_dates?.forEach(item => {
        return arrayDates.push(this.$config.convertDataBR(item));
      });

      return arrayDates.join(" ~ ");
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  mounted() {
    this.$config.getEstados("9e1bf96ca2754ee6596f26fd6e6b5cc2");

    this.$relatorios_analiticos.getCanaisDeVenda();
    this.$relatorios_analiticos.getFormasDePagamento();
    if (!this.isAdmin) {
      this.$produtos_gerenciar.getProdutos(
        this.$axios.getLocal("oe_user_info")?.data?.loja
      );
      return;
    }
    this.$loja_gerenciar.getRegionais();
  },
  destroyed() {
    this.$relatorios_analiticos.limpaFiltrosOmni();
  },
};
</script>
<style scoped></style>
